import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { AuthService } from './auth/auth.service';
import { DataService } from './data/data.service';
import { ViewService } from './view/view.service';
import { UserService } from './user/user.service';
import { ContentService } from './content/content.service';
import { AspectService } from './aspect/aspect.service';
import { SearchService } from './search/search.service';
import { ImportService } from './import/import.service';
import { SecureService } from './secure/secure.service';

import { UrlHelper } from './url-helper';

@NgModule({ declarations: [], imports: [CommonModule], providers: [
        AuthService,
        DataService,
        ViewService,
        ContentService,
        AspectService,
        UserService,
        SearchService,
        ImportService,
        SecureService,
        UrlHelper,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class ServiceModule { }
export * from './auth/auth.service';
export * from './data/data.service';
export * from './view/view.service';
export * from './content/content.service';
export * from './aspect/aspect.service';
export * from './user/user.service';
export * from './search/search.service';
export * from './import/import.service';
export * from './secure/secure.service';
export * from './url-helper';
